var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "iw-mgt"
  }, [_c('div', {
    staticClass: "iw-mgt-inner"
  }, [_c('div', {
    staticClass: "iw-mgt-search"
  }, [_c('div', {
    staticClass: "iw-search-bar iw-mgt-search-inner"
  }, [_c('span', {
    staticClass: "material-symbols-outlined text-stone-400 text-[20px]"
  }, [_vm._v("search")]), _c('Input', {
    staticClass: "search_input",
    attrs: {
      "placeholder": $t("l42c8w7", "请输入应用名称"),
      "clearable": ""
    },
    model: {
      value: _vm.searchKeyword,
      callback: function ($$v) {
        _vm.searchKeyword = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "searchKeyword"
    }
  })], 1)]), _c('div', {
    staticClass: "iw-tab-bar"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showFadeLeft,
      expression: "showFadeLeft"
    }],
    staticClass: "iw-tabs-scroll-btn iw-tabs-scroll-btn--left",
    on: {
      "click": function ($event) {
        return _vm.scrollTabs('left');
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15 19l-7-7 7-7"
    }
  })])]), _c('div', {
    ref: "tabsRef",
    staticClass: "iw-tabs-wrap",
    on: {
      "scroll": _vm.onTabsScroll
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showFadeLeft,
      expression: "showFadeLeft"
    }],
    staticClass: "iw-tabs-fade iw-tabs-fade--left"
  }), _c('div', {
    staticClass: "iw-tabs"
  }, [_c('button', {
    staticClass: "iw-tab-btn",
    class: {
      'iw-tab-btn--active': _vm.active === 'ALL'
    },
    on: {
      "click": function ($event) {
        return _vm.setActive('ALL');
      }
    }
  }, [_vm._v(` ${$t("en402", "全部")} `)]), _c('button', {
    staticClass: "iw-tab-btn",
    class: {
      'iw-tab-btn--active': _vm.active === 'FAVORITES'
    },
    on: {
      "click": function ($event) {
        return _vm.setActive('FAVORITES');
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined text-[15px] align-middle mr-1",
    staticStyle: {
      "font-variation-settings": "'FILL' 1"
    }
  }, [_vm._v("star")]), _vm._v($t("cv51d84", "我的收藏")), _vm.favoriteCount > 0 ? _c('span', {
    staticClass: "ml-1 px-1.5 py-px rounded text-[10px]",
    staticStyle: {
      "background": "var(--surface-container-low, #f6f3f2)",
      "color": "var(--on-surface-dim, #9e9e9e)"
    }
  }, [_vm._v(_vm._s(_vm.favoriteCount))]) : _vm._e()]), _vm._l(_vm.orderedGroups, function (group) {
    return _c('button', {
      key: group.id,
      staticClass: "iw-tab-btn",
      class: {
        'iw-tab-btn--active': _vm.active === group.id
      },
      on: {
        "click": function ($event) {
          return _vm.setActive(group.id);
        }
      }
    }, [_vm._v(" " + _vm._s(group.name) + " ")]);
  })], 2), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showFadeRight,
      expression: "showFadeRight"
    }],
    staticClass: "iw-tabs-fade iw-tabs-fade--right"
  })]), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showFadeRight,
      expression: "showFadeRight"
    }],
    staticClass: "iw-tabs-scroll-btn iw-tabs-scroll-btn--right",
    on: {
      "click": function ($event) {
        return _vm.scrollTabs('right');
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9 5l7 7-7 7"
    }
  })])]), _c('nav', {
    staticClass: "iw-tab-actions"
  }, [_c('Tooltip', {
    attrs: {
      "content": $t("raq4mq6", "切换展示模式"),
      "placement": "bottom",
      "transfer": "",
      "transfer-class-name": "iw-tab-action-tooltip"
    }
  }, [!_vm.isMobile ? _c('button', {
    staticClass: "iw-tab-extra-btn",
    on: {
      "click": _vm.changeFlex
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "3",
      "width": "7",
      "height": "7"
    }
  }), _c('rect', {
    attrs: {
      "x": "14",
      "y": "3",
      "width": "7",
      "height": "7"
    }
  }), _c('rect', {
    attrs: {
      "x": "14",
      "y": "14",
      "width": "7",
      "height": "7"
    }
  }), _c('rect', {
    attrs: {
      "x": "3",
      "y": "14",
      "width": "7",
      "height": "7"
    }
  })])]) : _vm._e()]), _vm.shouldShowAppMarketTooltip ? _c('Tooltip', {
    attrs: {
      "content": $t("cf26q44", "应用市场"),
      "placement": "bottom",
      "transfer": "",
      "transfer-class-name": "iw-tab-action-tooltip"
    }
  }, [_c('button', {
    staticClass: "iw-tab-extra-btn",
    on: {
      "click": _vm.openAppMarket
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor"
    }
  }, [_c('line', {
    attrs: {
      "x1": "8",
      "y1": "6",
      "x2": "21",
      "y2": "6"
    }
  }), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "12",
      "x2": "21",
      "y2": "12"
    }
  }), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "18",
      "x2": "21",
      "y2": "18"
    }
  }), _c('line', {
    attrs: {
      "x1": "3",
      "y1": "6",
      "x2": "3.01",
      "y2": "6"
    }
  }), _c('line', {
    attrs: {
      "x1": "3",
      "y1": "12",
      "x2": "3.01",
      "y2": "12"
    }
  }), _c('line', {
    attrs: {
      "x1": "3",
      "y1": "18",
      "x2": "3.01",
      "y2": "18"
    }
  })])])]) : _c('button', {
    staticClass: "iw-tab-extra-btn",
    on: {
      "click": _vm.openAppMarket,
      "mouseleave": _vm.restoreAppMarketTooltip
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor"
    }
  }, [_c('line', {
    attrs: {
      "x1": "8",
      "y1": "6",
      "x2": "21",
      "y2": "6"
    }
  }), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "12",
      "x2": "21",
      "y2": "12"
    }
  }), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "18",
      "x2": "21",
      "y2": "18"
    }
  }), _c('line', {
    attrs: {
      "x1": "3",
      "y1": "6",
      "x2": "3.01",
      "y2": "6"
    }
  }), _c('line', {
    attrs: {
      "x1": "3",
      "y1": "12",
      "x2": "3.01",
      "y2": "12"
    }
  }), _c('line', {
    attrs: {
      "x1": "3",
      "y1": "18",
      "x2": "3.01",
      "y2": "18"
    }
  })])]), !_vm.isMobile && _vm.isAdmin ? _c('Tooltip', {
    attrs: {
      "content": $t("cf7dsp4", "应用管理"),
      "placement": "bottom-end",
      "transfer": "",
      "transfer-class-name": "iw-tab-action-tooltip"
    }
  }, [_c('button', {
    staticClass: "iw-tab-extra-btn",
    on: {
      "click": _vm.openAppManager
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined text-[18px]"
  }, [_vm._v("tune")])])]) : _vm.isAdmin ? _c('button', {
    staticClass: "iw-tab-extra-btn",
    on: {
      "click": _vm.openAppManager
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined text-[18px]"
  }, [_vm._v("tune")])]) : _vm._e()], 1)]), _c('div', {
    ref: "contentArea",
    staticClass: "iw-content"
  }, [!_vm.isAppListLoaded ? _c('div', {
    staticClass: "iw-loader-mask"
  }, [_c('div', {
    staticClass: "loader"
  })]) : _vm._e(), _vm.showFavQuickRow ? _c('section', {
    staticClass: "iw-fav-quick"
  }, [_c('div', {
    staticClass: "iw-fav-quick-header"
  }, [_c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('span', {
    staticClass: "material-symbols-outlined text-[20px]",
    staticStyle: {
      "font-variation-settings": "'FILL' 1",
      "color": "var(--secondary, #785a1a)"
    }
  }, [_vm._v("star")]), _c('h3', {
    staticClass: "font-serif text-base",
    staticStyle: {
      "color": "var(--on-surface, #323233)"
    }
  }, [_vm._v(` ${$t("cv51d84", "我的收藏")} `)]), _c('span', {
    staticClass: "font-label text-xs",
    staticStyle: {
      "color": "var(--on-surface-dim, #9e9e9e)"
    }
  }, [_vm._v("· " + _vm._s(_vm.favoriteCount) + ` ${$t("bwvy63", "个应用")}`)])]), _c('button', {
    staticClass: "font-label text-xs hover:underline",
    staticStyle: {
      "color": "var(--secondary, #785a1a)"
    },
    on: {
      "click": function ($event) {
        return _vm.setActive('FAVORITES');
      }
    }
  }, [_vm._v(` ${$t("dll6ti4", "查看全部")} `)])]), _c('div', {
    staticClass: "iw-fav-quick-list"
  }, _vm._l(_vm.favApps, function (app) {
    return _c('button', {
      key: app.id,
      staticClass: "iw-fav-pill",
      on: {
        "click": function ($event) {
          return _vm.choice(app);
        }
      }
    }, [_c('img', {
      staticClass: "w-7 h-7 rounded-lg flex-shrink-0",
      staticStyle: {
        "pointer-events": "none"
      },
      attrs: {
        "src": app.icon || _vm.defaultImg,
        "alt": ""
      }
    }), _c('span', {
      staticClass: "font-label text-sm whitespace-nowrap",
      staticStyle: {
        "color": "var(--on-surface, #323233)"
      }
    }, [_vm._v(_vm._s(app.name))])]);
  }), 0)]) : _vm._e(), _vm.active === 'FAVORITES' ? _c('div', {
    staticClass: "iw-section-wrap"
  }, [_vm.filteredFavApps.length > 0 ? _c('div', {
    staticClass: "grid w-full pb-5",
    class: _vm.gridClass
  }, _vm._l(_vm.filteredFavApps, function (app) {
    return _c('div', {
      key: app.id,
      staticClass: "iw-app-card group",
      class: {
        'iw-app-card--small': !_vm.showDetailCards
      },
      on: {
        "click": function ($event) {
          return _vm.choice(app);
        }
      }
    }, [_vm.showDetailCards ? [_c('div', {
      staticClass: "flex items-start justify-between mb-4"
    }, [_c('img', {
      staticClass: "w-12 h-12 rounded-xl flex-shrink-0",
      staticStyle: {
        "pointer-events": "none"
      },
      attrs: {
        "src": app.icon || _vm.defaultImg,
        "alt": ""
      }
    }), _c('div', {
      staticClass: "flex items-center space-x-1"
    }, [_c('button', {
      staticClass: "iw-fav-btn",
      class: _vm.isFav(app.id) ? 'iw-fav-btn--active' : '',
      attrs: {
        "disabled": _vm.isFavoriteSaving,
        "title": $t("b17iob4", "取消收藏")
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.toggleFav(app);
        }
      }
    }, [_c('span', {
      staticClass: "material-symbols-outlined text-[18px]",
      style: _vm.favIconStyle(app.id)
    }, [_vm._v("star")])]), _c('span', {
      staticClass: "iw-enter-icon material-symbols-outlined text-[14px]"
    }, [_vm._v("north_east")])])]), _c('h4', {
      staticClass: "font-label text-sm font-semibold mb-1.5",
      staticStyle: {
        "color": "var(--on-surface, #323233)"
      }
    }, [_c('text-ellipsis', {
      attrs: {
        "text": app.name
      }
    })], 1), _c('p', {
      staticClass: "font-body text-xs leading-relaxed flex-1",
      staticStyle: {
        "color": "var(--on-surface-dim, #9e9e9e)"
      }
    }, [_c('text-ellipsis', {
      attrs: {
        "text": app.description || '',
        "lineClamp": 3
      }
    })], 1)] : [_c('div', {
      staticClass: "relative flex justify-center"
    }, [_c('img', {
      staticClass: "rounded-xl",
      class: _vm.isMobile ? 'w-[48px] h-[48px]' : 'w-[44px] h-[44px]',
      staticStyle: {
        "pointer-events": "none"
      },
      attrs: {
        "src": app.icon || _vm.defaultImg,
        "alt": ""
      }
    }), _c('button', {
      staticClass: "iw-fav-btn iw-fav-btn--small absolute -top-1.5 -right-1.5",
      class: _vm.isFav(app.id) ? 'iw-fav-btn--active' : '',
      attrs: {
        "disabled": _vm.isFavoriteSaving,
        "title": $t("b17iob4", "取消收藏")
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.toggleFav(app);
        }
      }
    }, [_c('span', {
      staticClass: "material-symbols-outlined text-[12px]",
      style: _vm.favIconStyle(app.id)
    }, [_vm._v("star")])])]), _c('div', {
      class: _vm.isMobile ? 'mt-2' : 'mt-2 text-[14px] flex justify-center',
      staticStyle: {
        "color": "var(--on-surface, #323233)"
      }
    }, [_c('text-ellipsis', {
      staticClass: "font-medium",
      attrs: {
        "text": app.name,
        "lineClamp": 2,
        "textAlign": "center"
      }
    })], 1)]], 2);
  }), 0) : _vm.isAppListLoaded ? _c('div', {
    staticClass: "iw-empty"
  }, [_c('span', {
    staticClass: "material-symbols-outlined text-stone-300 text-[48px] mb-3",
    staticStyle: {
      "font-variation-settings": "'FILL' 0"
    }
  }, [_vm._v("star")]), _c('p', {
    staticClass: "font-serif text-lg mb-1",
    staticStyle: {
      "color": "var(--on-surface, #323233)"
    }
  }, [_vm._v(` ${$t("8b9dix5", "还没有收藏")} `)]), _c('p', {
    staticClass: "text-sm",
    staticStyle: {
      "color": "var(--on-surface-dim, #9e9e9e)"
    }
  }, [_vm._v(` ${$t("bsvb0eh", "点击应用卡片上的 ☆ 图标即可收藏")} `)])]) : _vm._e()]) : [_vm._l(_vm.visibleGroups, function (group) {
    return _c('section', {
      key: group.id,
      staticClass: "iw-section"
    }, [_c('div', {
      staticClass: "iw-section-header"
    }, [_c('div', {
      staticClass: "flex items-center space-x-3"
    }, [_c('h2', {
      staticClass: "font-serif text-xl",
      staticStyle: {
        "color": "var(--on-surface, #323233)"
      }
    }, [_vm._v(" " + _vm._s(group.name) + " ")]), _c('span', {
      staticClass: "px-2 py-0.5 rounded font-label text-xs",
      staticStyle: {
        "background": "rgba(120, 90, 26, 0.08)",
        "color": "var(--secondary, #785a1a)"
      }
    }, [_vm._v(_vm._s(_vm.getGroupAppCount(group.id)) + ` ${$t("bwvy63", "个应用")}`)])])]), _vm.isOracleGroup(group) ? [_vm._l([_vm.getOracleSplit(group.id)], function (split) {
      return [_vm.showOracleBento ? _c('div', {
        key: split && group.id + '-bento',
        staticClass: "grid grid-cols-12 gap-5"
      }, [split.opera ? _c('div', {
        staticClass: "col-span-12 lg:col-span-4 opera-card rounded-2xl p-8 relative overflow-hidden group cursor-pointer",
        on: {
          "click": function ($event) {
            return _vm.choice(split.opera);
          }
        }
      }, [_c('div', {
        staticClass: "absolute -top-20 -right-20 w-64 h-64 rounded-full opacity-30",
        staticStyle: {
          "background": "radial-gradient("
        }
      }), _c('div', {
        staticClass: "absolute inset-0 opacity-[0.06]",
        staticStyle: {
          "background-image": "linear-gradient(",
          "background-size": "32px 32px"
        }
      }), _c('button', {
        staticClass: "iw-fav-btn opera-fav-btn absolute top-4 right-4 z-20 w-8 h-8 rounded-full flex items-center justify-center transition-all",
        class: _vm.isFav(split.opera.id) ? 'opera-fav-btn--active' : '',
        attrs: {
          "disabled": _vm.isFavoriteSaving,
          "title": $t("hy6x2", "收藏")
        },
        on: {
          "click": function ($event) {
            $event.stopPropagation();
            return _vm.toggleFav(split.opera);
          }
        }
      }, [_c('span', {
        staticClass: "material-symbols-outlined text-[20px]",
        style: _vm.operaFavStyle(split.opera.id)
      }, [_vm._v("star")])]), _c('div', {
        staticClass: "relative z-10 flex flex-col min-h-[260px]"
      }, [_c('div', {
        staticClass: "flex items-center space-x-3 mb-8"
      }, [_c('svg', {
        attrs: {
          "width": "36",
          "height": "36",
          "viewBox": "0 0 36 36",
          "fill": "none",
          "xmlns": "http://www.w3.org/2000/svg",
          "aria-hidden": "true"
        }
      }, [_c('ellipse', {
        attrs: {
          "cx": "18",
          "cy": "18",
          "rx": "17",
          "ry": "17",
          "stroke": "#C74634",
          "stroke-width": "2.5",
          "fill": "none"
        }
      }), _c('ellipse', {
        attrs: {
          "cx": "18",
          "cy": "18",
          "rx": "9",
          "ry": "17",
          "stroke": "#C74634",
          "stroke-width": "2",
          "fill": "none"
        }
      }), _c('line', {
        attrs: {
          "x1": "1",
          "y1": "18",
          "x2": "35",
          "y2": "18",
          "stroke": "#C74634",
          "stroke-width": "2"
        }
      })]), _vm._m(0, true)]), _c('div', {
        staticClass: "w-8 mb-5",
        staticStyle: {
          "height": "1px",
          "background": "#c74634",
          "opacity": "0.4"
        }
      }), _c('h3', {
        staticClass: "font-serif text-3xl text-white mb-2 leading-tight"
      }, [_vm._v(" OPERA for China ")]), _c('span', {
        staticClass: "font-label text-[10px] tracking-[0.2em] mb-4",
        staticStyle: {
          "color": "#c74634",
          "opacity": "0.7"
        }
      }, [_vm._v($t("oiq6zd8", "核心酒店管理系统"))]), _c('p', {
        staticClass: "font-body text-sm leading-relaxed max-w-xs",
        staticStyle: {
          "color": "rgba(255, 255, 255, 0.6)"
        },
        domProps: {
          "innerHTML": _vm._s(split.opera.description || $t("haufjr1b", "面向中国市场的全功能酒店管理系统，提供前台接待、预订管理、客房控制及报表分析的一体化解决方案。"))
        }
      }), _vm._m(1, true)])]) : _vm._e(), _c('div', {
        staticClass: "col-span-12 grid gap-5",
        class: [split.opera ? 'lg:col-span-8 grid-cols-2 md:grid-cols-3' : 'lg:col-span-12 grid-cols-2 md:grid-cols-3 lg:grid-cols-4', split.opera && split.others.length <= 3 ? 'content-start' : '']
      }, _vm._l(split.others, function (app) {
        return _c('div', {
          key: app.id,
          staticClass: "iw-app-card iw-app-card--oracle group",
          on: {
            "click": function ($event) {
              return _vm.choice(app);
            }
          }
        }, [_c('div', {
          staticClass: "flex items-start justify-between mb-4"
        }, [_c('img', {
          staticClass: "w-12 h-12 rounded-xl flex-shrink-0",
          staticStyle: {
            "pointer-events": "none"
          },
          attrs: {
            "src": app.icon || _vm.defaultImg,
            "alt": ""
          }
        }), _c('div', {
          staticClass: "flex items-center space-x-1"
        }, [_c('button', {
          staticClass: "iw-fav-btn",
          class: _vm.isFav(app.id) ? 'iw-fav-btn--active' : '',
          attrs: {
            "disabled": _vm.isFavoriteSaving,
            "title": $t("hy6x2", "收藏")
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.toggleFav(app);
            }
          }
        }, [_c('span', {
          staticClass: "material-symbols-outlined text-[18px]",
          style: _vm.favIconStyle(app.id)
        }, [_vm._v("star")])]), _c('span', {
          staticClass: "iw-enter-icon material-symbols-outlined text-[14px]"
        }, [_vm._v("north_east")])])]), _c('h4', {
          staticClass: "font-label text-sm font-semibold mb-1.5",
          staticStyle: {
            "color": "var(--on-surface, #323233)"
          }
        }, [_c('text-ellipsis', {
          attrs: {
            "text": app.name
          }
        })], 1), _c('p', {
          staticClass: "font-body text-xs leading-relaxed flex-1",
          staticStyle: {
            "color": "var(--on-surface-dim, #9e9e9e)"
          }
        }, [_c('text-ellipsis', {
          attrs: {
            "text": app.description || '',
            "lineClamp": 3
          }
        })], 1)]);
      }), 0)]) : _c('div', {
        key: split && group.id + '-compact',
        staticClass: "grid w-full pb-4",
        class: _vm.gridClass
      }, _vm._l(_vm.getFilteredApps(group.id), function (app) {
        return _c('div', {
          key: app.id,
          staticClass: "iw-app-card group",
          class: {
            'iw-app-card--small': !_vm.showDetailCards
          },
          on: {
            "click": function ($event) {
              return _vm.choice(app);
            }
          }
        }, [_vm.showDetailCards ? [_c('div', {
          staticClass: "flex items-start justify-between mb-4"
        }, [_c('img', {
          staticClass: "w-12 h-12 rounded-xl flex-shrink-0",
          staticStyle: {
            "pointer-events": "none"
          },
          attrs: {
            "src": app.icon || _vm.defaultImg,
            "alt": ""
          }
        }), _c('div', {
          staticClass: "flex items-center space-x-1"
        }, [_c('button', {
          staticClass: "iw-fav-btn",
          class: _vm.isFav(app.id) ? 'iw-fav-btn--active' : '',
          attrs: {
            "disabled": _vm.isFavoriteSaving,
            "title": $t("hy6x2", "收藏")
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.toggleFav(app);
            }
          }
        }, [_c('span', {
          staticClass: "material-symbols-outlined text-[18px]",
          style: _vm.favIconStyle(app.id)
        }, [_vm._v("star")])]), _c('span', {
          staticClass: "iw-enter-icon material-symbols-outlined text-[14px]"
        }, [_vm._v("north_east")])])]), _c('h4', {
          staticClass: "font-label text-sm font-semibold mb-1.5",
          staticStyle: {
            "color": "var(--on-surface, #323233)"
          }
        }, [_c('text-ellipsis', {
          attrs: {
            "text": app.name
          }
        })], 1), _c('p', {
          staticClass: "font-body text-xs leading-relaxed flex-1",
          staticStyle: {
            "color": "var(--on-surface-dim, #9e9e9e)"
          }
        }, [_c('text-ellipsis', {
          attrs: {
            "text": app.description || '',
            "lineClamp": 3
          }
        })], 1)] : [_c('div', {
          staticClass: "relative flex justify-center"
        }, [_c('img', {
          staticClass: "rounded-xl",
          class: _vm.isMobile ? 'w-[48px] h-[48px]' : 'w-[44px] h-[44px]',
          staticStyle: {
            "pointer-events": "none"
          },
          attrs: {
            "src": app.icon || _vm.defaultImg,
            "alt": ""
          }
        }), _c('button', {
          staticClass: "iw-fav-btn iw-fav-btn--small absolute -top-1.5 -right-1.5",
          class: _vm.isFav(app.id) ? 'iw-fav-btn--active' : '',
          attrs: {
            "disabled": _vm.isFavoriteSaving,
            "title": $t("hy6x2", "收藏")
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.toggleFav(app);
            }
          }
        }, [_c('span', {
          staticClass: "material-symbols-outlined text-[12px]",
          style: _vm.favIconStyle(app.id)
        }, [_vm._v("star")])])]), _c('div', {
          class: _vm.isMobile ? 'mt-2' : 'mt-2 text-[14px] flex justify-center',
          staticStyle: {
            "color": "var(--on-surface, #323233)"
          }
        }, [_c('text-ellipsis', {
          staticClass: "font-medium",
          attrs: {
            "text": app.name,
            "lineClamp": 2,
            "textAlign": "center"
          }
        })], 1)]], 2);
      }), 0)];
    })] : _c('draggable', {
      staticClass: "grid w-full pb-4",
      class: _vm.gridClass,
      attrs: {
        "list": _vm.groupedApps[group.id] || [],
        "disabled": !!_vm.searchKeyword,
        "itemKey": "id",
        "delay": 100
      },
      on: {
        "change": function ($event) {
          return _vm.change($event, _vm.groupedApps[group.id] || []);
        }
      }
    }, _vm._l(_vm.getFilteredApps(group.id), function (app) {
      return _c('div', {
        key: app.id,
        staticClass: "iw-app-card group",
        class: {
          'iw-app-card--small': !_vm.showDetailCards
        },
        on: {
          "dragend": _vm.dragend,
          "click": function ($event) {
            return _vm.choice(app);
          }
        }
      }, [_vm.showDetailCards ? [_c('div', {
        staticClass: "flex items-start justify-between mb-4"
      }, [_c('img', {
        staticClass: "w-12 h-12 rounded-xl flex-shrink-0",
        staticStyle: {
          "pointer-events": "none"
        },
        attrs: {
          "src": app.icon || _vm.defaultImg,
          "alt": ""
        }
      }), _c('div', {
        staticClass: "flex items-center space-x-1"
      }, [_c('button', {
        staticClass: "iw-fav-btn",
        class: _vm.isFav(app.id) ? 'iw-fav-btn--active' : '',
        attrs: {
          "disabled": _vm.isFavoriteSaving,
          "title": $t("hy6x2", "收藏")
        },
        on: {
          "click": function ($event) {
            $event.stopPropagation();
            return _vm.toggleFav(app);
          }
        }
      }, [_c('span', {
        staticClass: "material-symbols-outlined text-[18px]",
        style: _vm.favIconStyle(app.id)
      }, [_vm._v("star")])]), _c('span', {
        staticClass: "iw-enter-icon material-symbols-outlined text-[14px]"
      }, [_vm._v("north_east")])])]), _c('h4', {
        staticClass: "font-label text-sm font-semibold mb-1.5",
        staticStyle: {
          "color": "var(--on-surface, #323233)"
        }
      }, [_c('text-ellipsis', {
        attrs: {
          "text": app.name
        }
      })], 1), _c('p', {
        staticClass: "font-body text-xs leading-relaxed flex-1",
        staticStyle: {
          "color": "var(--on-surface-dim, #9e9e9e)"
        }
      }, [_c('text-ellipsis', {
        attrs: {
          "lineClamp": 3,
          "text": app.description || ''
        }
      })], 1)] : [_c('div', {
        staticClass: "relative flex justify-center"
      }, [_c('img', {
        staticClass: "rounded-xl",
        class: _vm.isMobile ? 'w-[48px] h-[48px]' : 'w-[44px] h-[44px]',
        staticStyle: {
          "pointer-events": "none"
        },
        attrs: {
          "src": app.icon || _vm.defaultImg,
          "alt": ""
        }
      }), _c('button', {
        staticClass: "iw-fav-btn iw-fav-btn--small absolute -top-1.5 -right-1.5",
        class: _vm.isFav(app.id) ? 'iw-fav-btn--active' : '',
        attrs: {
          "disabled": _vm.isFavoriteSaving,
          "title": $t("hy6x2", "收藏")
        },
        on: {
          "click": function ($event) {
            $event.stopPropagation();
            return _vm.toggleFav(app);
          }
        }
      }, [_c('span', {
        staticClass: "material-symbols-outlined text-[12px]",
        style: _vm.favIconStyle(app.id)
      }, [_vm._v("star")])])]), _c('div', {
        class: _vm.isMobile ? 'mt-2' : 'mt-2 text-[14px] flex justify-center',
        staticStyle: {
          "color": "var(--on-surface, #323233)"
        }
      }, [_c('text-ellipsis', {
        staticClass: "font-medium",
        attrs: {
          "text": app.name,
          "lineClamp": 2,
          "textAlign": "center"
        }
      })], 1)]], 2);
    }), 0)], 2);
  }), _vm.isAppListLoaded && _vm.visibleGroups.length === 0 ? _c('div', {
    staticClass: "iw-empty"
  }, [_c('span', {
    staticClass: "material-symbols-outlined text-stone-300 text-[48px] mb-3"
  }, [_vm._v("inventory_2")]), _c('p', {
    staticClass: "font-serif text-lg mb-1",
    staticStyle: {
      "color": "var(--on-surface, #323233)"
    }
  }, [_vm._v(` ${$t("e4srdo4", "没有应用")} `)]), _c('p', {
    staticClass: "text-sm flex gap-2",
    staticStyle: {
      "color": "var(--on-surface-dim, #9e9e9e)"
    }
  }, [_c('span', [_vm._v($t("a18dkm5", "请去左上角"))]), _c('span', {
    staticClass: "font-semibold cursor-pointer hover:underline",
    staticStyle: {
      "color": "var(--secondary, #785a1a)"
    },
    on: {
      "click": _vm.openAppMarket
    }
  }, [_vm._v(_vm._s($t("p49dxo6", "\"应用市场\"")))]), _c('span', [_vm._v($t("ofz72", "购买"))])])]) : _vm._e()]], 2)]), _c('WeekInDetail', {
    ref: "weekInDetailRef",
    on: {
      "on-success": _vm.onSuccessUpdate
    }
  }), _c('WeekInAreaChars', {
    ref: "weekInAreaCharsRef",
    on: {
      "on-success": _vm.onSuccessUpdate
    }
  }), _c('UnitSelect', {
    ref: "UnitSelect"
  }), _c('OpenAppModal', {
    ref: "OpenAppModal"
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('p', {
    staticClass: "oracle-wordmark"
  }, [_vm._v("ORACLE")]), _c('p', {
    staticClass: "font-label text-[9px] tracking-[0.2em] mt-0.5",
    staticStyle: {
      "color": "rgba(255, 255, 255, 0.3)"
    }
  }, [_vm._v(" HOSPITALITY ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mt-auto pt-6 flex items-center justify-between"
  }, [_c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('span', {
    staticClass: "w-2 h-2 rounded-full animate-pulse",
    staticStyle: {
      "background": "#c74634",
      "box-shadow": "0 0 8px 1px #c74634"
    }
  }), _c('span', {
    staticClass: "font-label text-[10px] tracking-widest",
    staticStyle: {
      "color": "#fff8f1"
    }
  }, [_vm._v($t("gai3mj4", "系统在线"))])]), _c('div', {
    staticClass: "flex items-center space-x-2 px-4 py-2 rounded-lg font-label text-xs group-hover:translate-x-0.5 transition-all",
    staticStyle: {
      "background": "#fff8f1",
      "border": "1px solid rgba(255, 248, 241, 0.8)",
      "color": "#3d1a14"
    }
  }, [_c('span', [_vm._v($t("fugyk24", "立即进入"))]), _c('span', {
    staticClass: "material-symbols-outlined text-[14px] transition-transform group-hover:translate-x-0.5"
  }, [_vm._v("arrow_forward")])])]);
}];
export { render, staticRenderFns };